import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import AIgniva from "@/pages/AIgniva";
import Marcas from "@/pages/Marcas";
import MarcaDetalhe from "@/pages/MarcaDetalhe";
import Aplicacoes from "@/pages/Aplicacoes";
import Contactos from "@/pages/Contactos";
import Cotacao from "@/pages/Cotacao";
import Profissionais from "@/pages/Profissionais";
import Explorador from "@/pages/Explorador";
import Privacidade from "@/pages/Privacidade";
import InformacaoLegal from "@/pages/InformacaoLegal";

const Layout = ({ lang }) => {
  const location = useLocation();
  return (
    <LanguageProvider lang={lang}>
      <Header />
      <main key={`${lang}${location.pathname}`} className="page-enter">
        <Outlet />
      </main>
      <Footer />
    </LanguageProvider>
  );
};

const PageRoutes = () => (
  <>
    <Route index element={<Home />} />
    <Route path="a-igniva" element={<AIgniva />} />
    <Route path="marcas" element={<Marcas />} />
    <Route path="marcas/:slug" element={<MarcaDetalhe />} />
    <Route path="aplicacoes" element={<Aplicacoes />} />
    <Route path="explorador" element={<Explorador />} />
    <Route path="profissionais" element={<Profissionais />} />
    <Route path="contactos" element={<Contactos />} />
    <Route path="orcamento" element={<Cotacao />} />
    <Route path="privacidade" element={<Privacidade />} />
    <Route path="informacao-legal" element={<InformacaoLegal />} />
  </>
);

function App() {
  return (
    <div className="App bg-[#121316] min-h-screen text-[#E8E6E1]">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout lang="pt" />}>{PageRoutes()}</Route>
          <Route path="/en" element={<Layout lang="en" />}>{PageRoutes()}</Route>
          <Route path="/es" element={<Layout lang="es" />}>{PageRoutes()}</Route>
          <Route path="/fr" element={<Layout lang="fr" />}>{PageRoutes()}</Route>
          <Route path="/cotacao" element={<Navigate to="/orcamento" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
